var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isBrandingLoaded && _vm.isBranded)?_c('img',{staticClass:"powered-by-logo",attrs:{"src":require("@/assets/powered_by_ewn.svg"),"alt":_vm.$t('ewn.logo-alt')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }